import { endOfMonth, toNextMonth } from "../../../helpers/date-util.js";
import { select } from "../../../elements/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import Month from "../../../../models/period/Month.js";

/**
 * `monthPickerWidget` is a calendar date picker that restricts the
 * selection to months.
 *
 * The selected date is the last day of the selected month.
 */
export default class MonthPickerWidget extends Widget {
	constructor() {
		super(...arguments);

		this.onDateChanged = this._events.createEvent();
		this._allDates = [];
	}

	getSelectedDate() {
		return endOfMonth(this._selectedDate);
	}

	setRange(timespan) {
		this._allDates = this._makeMonthlyDates({ timespan });
		this.update();
	}

	setSelectedDate(date) {
		const matchingDate = this._getMatchingDate(date);

		if (!matchingDate) return;

		this._selectedDate = matchingDate;
		this.update();
	}

	renderContentOn(html) {
		if (!this._allDates.length) return;
		html.render(this._makeDropdown());
	}

	_makeDropdown() {
		this._selectedDate ??= this._allDates[0];

		return select({
			name: "month",
			items: this._allDates.map((date) => ({
				label: this._makeLabelForDate(date),
				value: date,
			})),
			selected: this._selectedDate,
			onChange: (value) => {
				this._selectedDate = value;
				this.onDateChanged.trigger(this.getSelectedDate());
			},
		});
	}

	_makeLabelForDate(date) {
		return `${this._getMonthName(date)} ${date.getFullYear()}`;
	}

	_getMonthName(date) {
		return new Month({ start: date }).getName().toString();
	}

	_makeMonthlyDates({ timespan }) {
		const dates = [];
		let currentDate = timespan.getStart();

		while (timespan.includes(currentDate)) {
			dates.push(currentDate);
			currentDate = toNextMonth(currentDate);
		}

		return dates;
	}

	_getMatchingDate(date) {
		return this._allDates.find(
			(aDate) =>
				this._getMonthName(date) === this._getMonthName(aDate) &&
				date.getFullYear() === aDate.getFullYear(),
		);
	}
}
